export enum DecisionKindEnum {
  APPROVE = "approve",
  REJECT = "reject",
}
